<template>
  <div class="d-none d-md-flex flex-column align-items-end">
    <div class="btn-group">
      <!-- OUTIL DE RECHERCHE -->
      <!-- <SearchButtonold v-if="showSearch" :searchConfig="searchConfig" @search="search($event)" /> -->
      <SearchButton
        v-if="showSearch"
        ref="searchButton"
        :searchConfig="searchConfig"
        @toggleInput="toggleSearchInput"
      />
      <Search-input
        v-if="showSearch"
        ref="searchInput"
        :config="searchConfig"
        @search="search($event)"
      />
      <!-- BOUTONS NON-NORMALISES -->
      <ApplicationHeaderButton
        v-for="(button, index) in customConnectedButtons"
        :buttonConfig="button"
        :key="index"
        @click.native="actionClick(button.action)"
      />
      <!-- BOUTON USER -->
      <ProfilButton
        v-if="showProfil"
        :profilConfig="profilConfig"
        @profilButtonClick="actionClick('profilButtonClick')"
      />
      <!-- BOUTON DECONNECTER -->
      <DisconnectButton
        v-if="showDisconnect"
        :disconnectConfig="disconnectConfig"
        @disconnect="$emit('disconnect')"
      />
    </div>
    <!-- user en texte sous les icônes -->
    <div v-if="showProfilText" class="mt-1_8 text-xs text-start text-sm-end">
      <p class="mb-0">
        <span :class="profilTextClass">{{ $store.getters['user/fullname'] }}</span>
      </p>
    </div>
      <Search-input-tablet
        v-if="showSearch"
        ref="searchInputTablet"
        class="d-none d-md-flex d-lg-none"
        :config="searchConfig"
        @search="search($event)"
      />
  </div>
</template>

<script>
import SearchButton from "./SearchButton";
import SearchInput from "./SearchInput";
import SearchInputTablet from "./SearchInputTablet";
/* import SearchButtonold from "./SearchButtonold"; */
import ApplicationHeaderButton from "./ApplicationHeaderButton";
import ProfilButton from "./ProfilButton";
import DisconnectButton from "./DisconnectButton";

export default {
  name: "BlocPriveConnected",
  props: {
    headerClass: { type: String, default: "" },
    disconnectConfig: { type: Object, default: () => {} },
    profilConfig: { type: Object, default: () => {} },
    searchConfig: { type: Object, default: () => {} },
    customConnectedButtons: { type: Array, default: () => [] }
  },
  computed: {
    showDisconnect() {
      return this.getKey(this.disconnectConfig, "show", false);
    },
    showProfil() {
      return this.getKey(this.profilConfig, "show", false);
    },
    showProfilText() {
      return this.getKey(this.profilConfig, "showText", false);
    },
    profilTextClass() {
      return this.prefixStringKey(this.profilConfig, "textClass", {
        prefix: "fw-bold "
      });
    },
    showSearch() {
      return this.getKey(this.searchConfig, "show", false);
    },
  },
  methods: {
    actionClick(action) {
      this.$emit(action);
    },
    search(searcherContent) {
      this.$emit("search", searcherContent);
    },
    toggleSearchInput() {
      this.$refs["searchInput"].toggleSearchInput();
    }
  },
  components: {
    /* SearchButtonold, */
    SearchButton,
    SearchInput,
    SearchInputTablet,
    ApplicationHeaderButton,
    ProfilButton,
    DisconnectButton
  }
};
</script>